export let config;
export function configure(opts) {
    config = opts;
}
export function resetConfiguration() {
    config = undefined;
}
//# sourceMappingURL=config.js.map